/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import pathify from 'vuex-pathify';

import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

import auth from './modules/auth';
import document from './modules/document';
import favoriteSearches from './modules/favorite-searches';
import manageDocuments from './modules/manage-documents';
import search from './modules/search';
import user from './modules/user';
import users from './modules/users';
import menu from './modules/menu';
import favoriteList from './modules/favorite-list';
import documentsFavoriteLists from './modules/documents-favorite-lists';
import usersFavoriteLists from './modules/users-favorite-lists';

Vue.use(Vuex);

auth.namespaced = true;
document.namespaced = true;
favoriteSearches.namespaced = true;
manageDocuments.namespaced = true;
favoriteList.namespaced = true;
documentsFavoriteLists.namespaced = true;
usersFavoriteLists.namespaced = true;
search.namespaced = true;
user.namespaced = true;
users.namespaced = true;
menu.namespaced = true;

const vuexLocal = new VuexPersistence({
    storage: window.localStorage
});

export default new Vuex.Store({
    modules: {
        auth,
        document,
        favoriteSearches,
        manageDocuments,
        favoriteList,
        documentsFavoriteLists,
        usersFavoriteLists,
        search,
        user,
        users,
        menu
    },
    getters,
    mutations,
    state,
    actions,
    plugins: [vuexLocal.plugin, pathify.plugin],
    strict: process.env.NODE_ENV !== 'production'
});
